import actions from './ContactsActions';
import initialState from './ContactsInitialState';
import reducers from './ContactsReducer';

export default {
  actions,
  initialState,
  reducers,
};
